import { createFileRoute } from '@tanstack/react-router'
import LoginForm from '../../components/LoginForm/LoginForm'
import CenteredPage from '../../views/styled/CenteredPage/CenteredPage'
import useRecaptcha from '../../hooks/services/useRecaptcha'

export const Route = createFileRoute('/login')({
  component: Index
})

function Index() {
  useRecaptcha()
  return (
    <CenteredPage>
      <LoginForm />
    </CenteredPage>
  )
}
